<div
class="header h-[55px] flex justify-start items-center !pl-[20px] !pt-[48px] !pb-[32px] bg-[#DEE2E6]"
>
<p class="!m-0 flex">
  Select From Project Design
</p>
<div style="position: absolute; top: 17px; right: 36px">
  <img
    src="assets/icons/cross-icon.svg"
    (click)="close()"
    alt="cross icon"
    class="cursor-pointer !fixed"
  />
</div>
</div>
  <nav class="tab-container  !pb-[20px]">
    <div>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Drawing'}" (click)="setTab('Drawing', 'drawing')">
        Drawings
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Specifications', 'inactive': currentTab !== 'Specifications' }" (click)="setTab('Specifications', 'specifications')">
        Specifications
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Calculations', 'inactive': currentTab !== 'Calculations' }" (click)="setTab('Calculations', 'calculations')">
        Calculations
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Surveys, Reports and Studies', 'inactive': currentTab !== 'Surveys, Reports and Studies' }" (click)="setTab('Surveys, Reports and Studies', 'surverys_reports_studies')">
        Surveys, Reports and Studies
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Design Review Reports', 'inactive': currentTab !== 'Design Review Reports' }" (click)="setTab('Design Review Reports', 'design_review_reports')">
        Design Review Reports
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Permits and Applications', 'inactive': currentTab !== 'Permits and Applications' }" (click)="setTab('Permits and Applications', 'permits_and_applications')">
        Permits and Applications
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Design Sign Off', 'inactive': currentTab !== 'Design Sign Off' }" (click)="setTab('Design Sign Off', 'design_signoff')">
        Design Sign Off
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'RFI', 'inactive': currentTab !== 'RFI' }" (click)="setTab('RFI', 'rfi')">
        RFI
      </button>
      <button class="button" [ngClass]="{ 'active': currentTab === 'Addendums', 'inactive': currentTab !== 'Addendums' }" (click)="setTab('Addendums', '')">
        Addendums
      </button>
    </div>
  </nav>
    
  <div class="container mx-auto">
    <div class="overflow-x-auto"
    style="
        min-height: calc(70vh - 180px);
        overflow-y: auto;
        border: 1px solid #ddd;
      ">
      <table class="min-w-full bg-white">
        <thead class="sticky top-0  z-20">
          <tr class="w-full bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
            <th class="py-3 px-6 text-left w-[5%]">
              <input type="checkbox" [(ngModel)]="selectActiveTabAllFiles" (change)="toggleSelectAll()">
            </th>
            <th class="py-3 px-6 text-left text-[#21252A] w-[20%] ">Drawing No.</th>
            <th class="py-3 px-6 text-left text-[#21252A] w-[30%]">Title</th>
            <th class="py-3 px-6 text-left text-[#21252A]">Revision</th>
            <th class="py-3 px-6 text-left text-[#21252A]">Date</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 text-sm font-light">
          <tr *ngFor="let design of getCurrentTabDesigns()" class="border-b border-gray-200 hover:bg-gray-100">
            <td class="py-3 px-6 text-left whitespace-nowrap w-[5%]">
              <input type="checkbox" [(ngModel)]="design.selected" (change)="toggleCurrentTabFileSelection(design)">
            </td>
            <td class="py-3 px-6 text-[#000]">A001</td>
            <td class="py-3 px-6 text-[#000]">{{ design.title.split('.')[0] }}</td>
            <td class="py-3 px-10 text-[#000] text-[13.458px]">--</td>
            <td class="py-3 px-6 text-[#000] ">{{ design.created_at |date: 'MM/dd/yyyy'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="!w-[100%] flex justify-end items-center">

      </div>
  </div>
  <div class="!w-[100%] flex justify-end items-center p-5 pt-0 sticky bottom-0 bg-white shadow-md">
    <button
      class="!w-[auto] !h-[auto] !py-[10px] !px-[20px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="processSelectedDesigns(true)"
    >
      Select
    </button>
  </div>
  
